export default {
  apiTrafficManager: process.env.VUE_APP_BACKEND_URL || 'https://nakdan-dev.loadbalancer3.dicta.org.il'
}
